import {
    isFunction
} from "./main";
import {
    deepClone
} from "./obj";

// полседовательное выполнение асинхронных функций
// в голом виде не рекомендуется использовать
export function series(series, callback, context) {
    if ( !isFunction(callback) ) {
        callback = function() {};
    }

    series = deepClone(series);
    let results = [];
    let resultErr = null;

    if ( !context ) {
        context = this;
    }

    function iterate() {
        let func = series.shift();


        let called = false;

        func.call(context, function(err, result) {
            if ( called ) {
                return;
            }
            called = true;

            results.push(result);

            if ( err || series.length === 0 ) {
                return stop(err);
            }

            iterate();
        });
    }

    function stop(err) {
        if ( err ) {
            resultErr = err;
        }

        callback.call(context, resultErr, results);
    }

    if ( series.length === 0 ) {
        setTimeout(callback.bind(context, null, []), 0);
    } else {
        iterate();
    }

}

export function parallel(funcs, callback, context) {
    if ( !isFunction(callback) ) {
        callback = function() {};
    }

    if ( !context ) {
        context = this;
    }

    let results = [];
    let resultErr = null;
    let count = funcs.length;
    let stoped = false;
    let loaded = 0;
    function iterate(func, index) {
        if ( stoped ) {
            return;
        }

        func.call(context, function(err, result) {
            if ( stoped ) {
                return;
            }

            results[index] = result;
            loaded++;

            if ( err || loaded >= count ) {
                return stop(err);
            }
        });
    }

    function stop(err) {
        stoped = true;
        if ( err ) {
            resultErr = err;
        }

        callback.call(context, resultErr, results);
    }

    funcs.forEach(iterate);
    if ( funcs.length === 0 ) {
        stop();
    }
}

export function waitProp(obj, propName, callback) {
    function wait() {
        if ( obj[propName] ) {
            callback(obj);
        } else {
            // потеряет стек:
            // setTimeout(wait, 5);

            // не потеряет стек:
            setTimeout(function() {
                wait();
            }, 5);
        }
    }

    wait();
}

export function seriesPromise(funcs) {
    let context = this;

    return new Promise(function(resolve, reject) {
        series.call(context, funcs, function(err, result) {
            if ( err ) {
                reject(err);
            } else {
                resolve(result);
            }
        });
    });
}

export function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
